'use strict'

export default class editnewusers {
    constructor(
        address = "",
        imageFile = ""
    ) {
        this.address = address
        this.imageFile = imageFile
    }

}